
import { MapLocation } from '@/types/location';

// Arena Fitness Gym Locations
export const arenaFitnessGyms: MapLocation[] = [
  {
    id: 30001,
    name: "Arena Fitness Gym - Riyadh (Al Mathar)",
    type: "Gym",
    devices: 3,
    coordinates: [24.689491317205817, 46.671912266949434],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 30002,
    name: "Arena Fitness Gym - Riyadh (Hittin)",
    type: "Gym",
    devices: 2,
    coordinates: [24.752772971694423, 46.61482267221941],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 30003,
    name: "Arena Fitness Gym - Jeddah (Al Nahda)",
    type: "Gym",
    devices: 2,
    coordinates: [21.626918598117395, 39.13190290659051],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
